import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import { API_NAMES, initApi } from '@usas/ui-web/utils/HttpApiHelper';

const getClubMemberRequirementsData = (orgUnitId, state, setState) => {
  if (orgUnitId) {
    const newState = {
      ...state,
      orgUnitId
    };

    const api = initApi(API_NAMES.COMMON, newState, setState);

    const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
    const url = `/OrgUnit/${orgUnitIdForUrl}/memberRequirement`;

    return api.executeArray ? api.executeArray(url, 'GET') : null;
  }
};

const INITIAL_CLUB_MEMBER_REQUIREMENTS_STATE = {
  ...BASIC_INITIAL_STATE,
  orgUnitId: ''
};

const ClubMemberRequirementsData = {
  INITIAL_CLUB_MEMBER_REQUIREMENTS_STATE,
  getClubMemberRequirementsData
};

export default ClubMemberRequirementsData;